import { useState } from "react";
import { Outlet, NavLink, useLocation } from "react-router-dom";
import { Sidebar } from "@/components/Sidebar";
import { AskFlapiBar } from "@/components/AskFlapiBar";
import { useStudio } from "@/context/StudioContext";
import { MOBILE_NAV } from "@/config/nav";
import { List, BellRinging, CaretDown } from "@phosphor-icons/react";
import { cn } from "@/lib/utils";

export function Layout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const loc = useLocation();
  const { active, activeId } = useStudio();

  return (
    <div className="grain flex h-screen overflow-hidden bg-[#050505]">
      <Sidebar mobileOpen={mobileOpen} onClose={() => setMobileOpen(false)} />

      <div className="flex-1 flex flex-col min-w-0 relative z-10">
        {/* Top bar */}
        <header className="lg:hidden h-16 shrink-0 flex items-center justify-between px-4 border-b border-white/5 glass">
          <button onClick={() => setMobileOpen(true)} data-testid="menu-open" className="text-white"><List size={24} /></button>
          <button onClick={() => setMobileOpen(true)} data-testid="mobile-studio" className="flex items-center gap-2">
            <span className="text-lg">{active.emoji}</span>
            <span className="font-display font-extrabold text-white truncate max-w-[140px]">{active.name}</span>
            <CaretDown size={14} className="text-zinc-500" />
          </button>
          <NavLink to="/notifications" className="text-zinc-300"><BellRinging size={22} weight="duotone" /></NavLink>
        </header>

        <main className="flex-1 overflow-y-auto px-4 sm:px-8 py-6 sm:py-8 pb-40 lg:pb-32">
          <div key={activeId} className="max-w-7xl mx-auto w-full">
            <Outlet />
          </div>
        </main>

        {/* Mobile bottom nav */}
        <nav className="lg:hidden fixed bottom-0 inset-x-0 z-30 glass border-t border-white/10 flex items-center justify-around h-14">
          {MOBILE_NAV.map((item) => {
            const Icon = item.icon;
            const active = loc.pathname === item.to;
            return (
              <NavLink key={item.to} to={item.to} data-testid={`mnav-${item.label.toLowerCase()}`}
                className={cn("flex flex-col items-center gap-0.5 text-[10px]", active ? "text-[#00E5FF]" : "text-zinc-500")}>
                <Icon size={20} weight={active ? "fill" : "duotone"} />
                {item.label}
              </NavLink>
            );
          })}
        </nav>
      </div>

      <AskFlapiBar />
    </div>
  );
}
